import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useNotifications } from "../context/NotificationsContext";

/*
 * Where the service worker sends a click on an OS notification:
 * `/notification-target?nid=&type=&id=&branch=&params=` — also the push's
 * `webpush.fcm_options.link`. Being an ordinary route, a signed-out user goes
 * through login and comes back here. It marks the item read and replaces
 * itself with the mapped page (or a safe fallback).
 */

/** `params` is the push's `target_params` JSON string; anything unreadable is no params. */
const parseParams = (raw) => {
  if (!raw) return {};
  try {
    const value = JSON.parse(raw);
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
  } catch {
    return {};
  }
};
export default function NotificationTarget() {
  const [params] = useSearchParams();
  const { openTarget } = useNotifications();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const target = {
      type: params.get("type"),
      id: params.get("id"),
      params: parseParams(params.get("params")),
    };

    openTarget(
      { id: params.get("nid") || null, target, branchId: params.get("branch") || null },
      { replace: true }
    ).then((opened) => {
      if (!opened) navigate("/", { replace: true });
    });
  }, [navigate, openTarget, params]);

  return null;
}
